import React from 'react'
import { MDBIcon } from 'mdb-react-ui-kit'
import { useNavigate, Link } from 'react-router-dom'
const ApplicationControl = ({ percentage, eligibility, title, applicationNo, application, isApplicationCompleted, route, applicationTitle }) => {
    console.log("percentage", percentage)
    const navigate = useNavigate()

    const applicationFormTitle = applicationTitle.replace(/ /g, "-")
    const applicationRoute = `${route}-${applicationNo}-${applicationFormTitle}`

    return (
        <div className="flex flex-col md:grid md:grid-cols-[36%_16%_16%_16%_16%] bg-white border md:border-t-0 md:border-x-0 md:border-b border-gray-200 mt-2 md:mt-0 hover:bg-gray-50 transition-colors rounded-md md:rounded-none overflow-hidden">
            {/* Form Title */}
            <div className='px-4 py-3 md:border-r border-gray-200 border-l-[4px] border-l-[#042e2e] rounded-l-md md:rounded-none min-w-0 break-words overflow-hidden'>
                <span className="md:hidden font-semibold text-[11px] text-gray-500 uppercase tracking-wider block mb-1">Application Form</span>
                <div className='font-bold text-sm text-gray-800'>
                    {title && title.map((e, i) => (
                        <p key={i} className='leading-snug mb-0'>{e}</p>
                    ))}
                </div>
            </div>

            {/* Application No */}
            <div className='px-4 py-3 md:border-r border-gray-200 border-b md:border-b-0 md:text-center flex md:block justify-between items-center min-w-0 break-words overflow-hidden'>
                <span className="md:hidden font-semibold text-[11px] text-gray-500 uppercase tracking-wider">Application No.</span>
                <span className='text-sm text-gray-800 font-medium break-all'>{applicationNo || '-'}</span>
            </div>

            {/* Fees */}
            <div className='px-4 py-3 md:border-r border-gray-200 border-b md:border-b-0 md:text-center flex md:block justify-between items-center min-w-0 break-words overflow-hidden'>
                <span className="md:hidden font-semibold text-[11px] text-gray-500 uppercase tracking-wider">Application Fees</span>
                <span className='text-sm text-gray-800 font-medium whitespace-nowrap'>₹ 1300.00</span>
            </div>

            {/* Eligibility */}
            <div className='px-4 py-3 md:border-r border-gray-200 border-b md:border-b-0 md:text-center flex md:block justify-between items-center min-w-0 overflow-hidden'>
                <span className="md:hidden font-semibold text-[11px] text-gray-500 uppercase tracking-wider">Eligibility & Syllabus</span>
                <a target="_blank" rel="noreferrer" href={eligibility} className="hover:opacity-80 transition-opacity flex items-center justify-center">
                    <MDBIcon className='text-red-600 text-2xl md:text-3xl' far icon="file-pdf" />
                </a>
            </div>

            {/* Action */}
            <div className='px-4 py-3 md:text-center flex flex-col justify-center items-end md:items-center min-w-0 overflow-hidden'>
                {isApplicationCompleted ? (
                    <Link to={`/student-dashboard/${route}/form`} target="_blank" className="bg-[#042e2e] hover:bg-[#074646] text-white px-3 py-1.5 rounded text-xs font-semibold uppercase tracking-wide transition-colors w-full md:w-auto text-center block" style={{ textDecoration: 'none' }}>
                        Download
                    </Link>
                ) : (applicationNo && applicationNo !== "null") ? (
                    <div className="flex flex-col items-end md:items-center w-full">
                        <button onClick={() => navigate(`/student-dashboard/${route}-${applicationNo}`)} className="bg-[#042e2e] hover:bg-[#074646] text-white px-4 py-1.5 rounded text-xs font-semibold uppercase tracking-wide transition-colors mb-1.5 w-full md:w-auto overflow-hidden text-ellipsis whitespace-nowrap">
                            Continue
                        </button>
                        <span className='text-[11px] text-gray-500 text-right md:text-center font-medium leading-tight'>
                            <span className='font-bold text-[#042e2e]'>{percentage || "0"}%</span><br className="hidden md:block" /> Completed
                        </span>
                    </div>
                ) : (
                    <button onClick={() => application(route)} className="bg-[#042e2e] hover:bg-[#074646] text-white px-4 py-1.5 rounded text-xs font-semibold uppercase tracking-wide transition-colors w-full md:w-auto overflow-hidden text-ellipsis whitespace-nowrap">
                        Apply Now
                    </button>
                )}
            </div>
        </div>
    )
}

export default ApplicationControl